export default "__VITE_ASSET__CEihtBqd__"